module.exports = {"id":"216475","name":"Morales","rating":"78","photo":"./data/images/photos/2/216475.png","club":{"name":"Levante UD","logo":"./data/images/clubs/LevanteUD.png"},"positions":["MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Morales0.json
// module id = 3074
// module chunks = 0